<div class="mx-auto px-4 sm:px-6 lg:px-8 mb-16 animate-fade-in" *ngIf="advisor()">
    
    <div class="flex items-center justify-between mb-8">
        <button class="flex items-center text-gray-500 hover:text-indigo-600 font-semibold transition-colors group">
            <svg class="w-5 h-5 mr-2 transform group-hover:-translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" /></svg>
            Back to Directory
        </button>
        <div class="flex flex-wrap gap-4">
            <button type="button" (click)="editAdvisor(advisorId)" class="flex items-center px-5 py-2.5 rounded-xl border-2 border-gray-200 font-bold text-gray-600 hover:border-gray-300 hover:bg-gray-50 transition-all active:scale-95 group">
                <svg class="w-4 h-4 mr-2 text-gray-400 group-hover:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                </svg>
                Edit Profile
            </button>
        
            <button class="flex items-center px-6 py-2.5 rounded-xl bg-indigo-600 text-white font-bold shadow-sm shadow-indigo-100 hover:bg-indigo-700 hover:shadow-indigo-200 transition-all active:scale-95 group">
                <svg class="w-4 h-4 mr-2 text-indigo-200 group-hover:text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 11V7a4 4 0 10-8 0v4M5 11h14a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2z" />
                </svg>
                Reset Password
            </button>
        
            <button class="flex items-center px-6 py-2.5 rounded-xl bg-emerald-500 text-white font-bold shadow-sm shadow-emerald-100 hover:bg-emerald-600 hover:shadow-emerald-200 transition-all active:scale-95 group" (click)="assignProperty()">
                <svg class="w-4 h-4 mr-2 text-emerald-100 group-hover:text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
                </svg>
                Assign Property
            </button>
        </div>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-12 gap-8">
        
        <div class="lg:col-span-4 space-y-8">
            <div class="bg-white rounded-[2.5rem] border border-gray-100 shadow-sm overflow-hidden animate-slide-up">
                <div class="h-32 bg-gradient-to-br from-indigo-500 to-purple-600"></div>
                <div class="px-8 pb-10">
                    <div class="relative -mt-16 mb-6">
                        <img [src]="advisor()?.advisorImg || 'https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&w=256&q=80'" 
                             class="w-32 h-32 rounded-3xl border-4 border-white shadow-sm object-cover" alt="Advisor">
                        <span class="absolute bottom-2 right-2 w-6 h-6 bg-green-500 border-4 border-white rounded-full"></span>
                    </div>
                    
                    <h1 class="text-3xl font-extrabold text-gray-900">{{advisor()?.name}}</h1>
                    <p class="text-indigo-600 font-bold mt-1 uppercase text-sm tracking-wider">{{ advisor()?.specialization }}</p>

                    <!-- <p class="text-indigo-600 font-bold flex items-center mt-1">
                        <svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>
                        4.9 <span class="text-gray-400 font-medium ml-1">(120+ Reviews)</span>
                    </p> 
                    <p class="text-indigo-600 font-bold flex items-center mt-1">
                        <span class="text-xs text-gray-400 font-medium ml-1">{{advisor()?.specialization }}</span>
                    </p>  -->

                    <div class="mt-8 space-y-4">
                        <div class="flex items-center p-4 bg-gray-50 rounded-2xl hover:bg-indigo-50 transition-colors group">
                            <div class="w-10 h-10 rounded-xl bg-white shadow-sm flex items-center justify-center text-indigo-600 group-hover:scale-110 transition-transform">
                                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/></svg>
                            </div>
                            <div class="ml-4 text-sm">
                                <p class="text-gray-400 font-medium">Email Address</p>
                                <p class="text-gray-900 font-bold">{{advisor()?.email}}</p>
                            </div>
                        </div>
                        <div class="flex items-center p-4 bg-gray-50 rounded-2xl hover:bg-indigo-50 transition-colors group">
                            <div class="w-10 h-10 rounded-xl bg-white shadow-sm flex items-center justify-center text-indigo-600 group-hover:scale-110 transition-transform">
                                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/></svg>
                            </div>
                            <div class="ml-4 text-sm">
                                <p class="text-gray-400 font-medium">Phone Number</p>
                                <p class="text-gray-900 font-bold">{{advisor()?.phone }}</p>
                            </div>
                        </div>
                        <div class="flex items-center p-4 bg-gray-50 rounded-2xl hover:bg-indigo-50 transition-colors group">
                            <div class="w-10 h-10 rounded-xl bg-white shadow-sm flex items-center justify-center text-indigo-600 group-hover:scale-110 transition-transform">
                                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/></svg>
                            </div>
                            <div class="ml-4 text-sm">
                                <p class="text-gray-400 font-medium">Alternative Phone Number</p>
                                <p class="text-gray-900 font-bold">{{advisor()?.alternativePhone}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="lg:col-span-8 space-y-8">
            
            <div class="grid grid-cols-2 md:grid-cols-4 gap-4 animate-fade-in-delayed">
                <div class="bg-white p-6 rounded-3xl border border-gray-100 shadow-sm shadow-indigo-50/20 text-center">
                    <p class="text-gray-400 text-xs font-bold uppercase tracking-widest mb-1">Experience</p>
                    <p class="text-2xl font-black text-gray-900">{{advisor()?.experience }} Yrs</p>
                </div>
                <div class="bg-white p-6 rounded-3xl border border-gray-100 shadow-sm shadow-indigo-50/20 text-center">
                    <p class="text-gray-400 text-xs font-bold uppercase tracking-widest mb-1">Closed Deals</p>
                    <p class="text-2xl font-black text-gray-900">0</p>
                </div>
                <div class="bg-white p-6 rounded-3xl border border-gray-100 shadow-sm shadow-indigo-50/20 text-center">
                    <p class="text-gray-400 text-xs font-bold uppercase tracking-widest mb-1">Active Props</p>
                    <p class="text-2xl font-black text-indigo-600">0</p>
                </div>
                <!-- <div class="bg-white p-6 rounded-3xl border border-gray-100 shadow-sm shadow-indigo-50/20 text-center">
                    <p class="text-gray-400 text-xs font-bold uppercase tracking-widest mb-1">Consult Fee</p>
                    <p class="text-2xl font-black text-green-600">{{(advisor()?.consultationFee ?? 0) | inrShort  }}</p>
                </div> -->
            </div>

            <div class="grid grid-cols-2 md:grid-cols-4 gap-4 animate-fade-in-delayed">
                <!-- <div class="bg-white p-6 rounded-3xl border border-gray-100 shadow-xl shadow-indigo-50/20 text-center">
                    <p class="text-gray-400 text-xs font-bold uppercase tracking-widest mb-1">Onboarding Date</p>
                    <p class="text-2xl font-black text-gray-900">{{ advisor()?.createdAt }}</p>
                </div> -->
                <div class="bg-white p-6 rounded-3xl border border-gray-100 shadow-sm shadow-indigo-50/20 text-center">
                    <p class="text-gray-400 text-xs font-bold uppercase tracking-widest mb-1">Location</p>
                    <p class="text-2xl font-black text-gray-900 line-clamp-1">{{ advisor()?.location }}</p>
                </div>
                <div class="bg-white p-6 rounded-3xl border border-gray-100 shadow-sm shadow-indigo-50/20 text-center">
                    <p class="text-gray-400 text-xs font-bold uppercase tracking-widest mb-1">Assigned</p>
                    <p class="text-2xl font-black text-indigo-600">{{ advisor()?.assignedProperty?.length || 0 }}</p>
                </div>
                <div class="bg-white p-6 rounded-3xl border border-gray-100 shadow-sm shadow-indigo-50/20 text-center">
                    <p class="text-gray-400 text-xs font-bold uppercase tracking-widest mb-1">Status</p>
                    <p class="text-2xl font-black text-green-600">{{'Active'}}</p>
                </div>
                <div class="bg-white p-6 rounded-3xl border border-gray-100 shadow-sm shadow-indigo-50/20 text-center">
                    <p class="text-gray-400 text-xs font-bold uppercase tracking-widest mb-1">Role</p>
                    <p class="text-2xl font-black text-green-600 role">{{advisor()?.role?.label}}</p>
                </div>
            </div>

            <div class="bg-white p-8 rounded-[2.5rem] border border-gray-100 shadow-sm animate-slide-up" style="animation-delay: 0.1s;">
                <h3 class="text-2xl font-extrabold text-gray-900 mb-4">Professional Bio</h3>
                <p class="text-gray-600 leading-relaxed italic border-l-4 border-indigo-500 pl-6">
                    "{{ advisor()?.aboutAdvisor }}"
                </p>
            </div>

            <div class="animate-slide-up" style="animation-delay: 0.2s;">
                <div class="flex items-center justify-between mb-6">
                    <h3 class="text-2xl font-extrabold text-gray-900">Assigned Properties</h3>
                    <button class="text-indigo-600 font-bold hover:underline">View All Listings</button>
                </div>
                
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div class="group bg-white rounded-3xl overflow-hidden border border-gray-100 shadow-sm hover:shadow-md transition-all duration-500" *ngFor="let item of assignedPro">
                        <div class="relative h-48 overflow-hidden">
                            @if(item?.galleryImage?.length > 0){
                                <img [src]="item?.galleryImage[0]" 
                                class="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" alt="Prop">
                           <div class="absolute top-4 left-4 px-3 py-1 bg-white/90 backdrop-blur shadow-sm rounded-lg text-xs font-black text-indigo-600">ID: #</div>
                            }@else{
                                <img [src]="'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=600&q=80'" 
                                 class="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" alt="Prop">
                            <div class="absolute top-4 left-4 px-3 py-1 bg-white/90 backdrop-blur shadow-sm rounded-lg text-xs font-black text-indigo-600">ID: #</div>
                            }
                            
                        </div>
                        <div class="p-6">
                            <h4 class="text-xl font-bold text-gray-900 mb-1">{{item?.name}}</h4>
                            <p class="text-gray-400 text-sm mb-4">{{item?.location}}</p>
                            <div class="flex items-center justify-between border-t border-gray-50 pt-4">
                                <span class="text-indigo-600 font-extrabold">{{ formatPriceDisplay(item.price) }}</span>
                                <button (click)="viewDetails(item)" class="p-2 bg-indigo-50 text-indigo-600 rounded-xl group-hover:bg-indigo-600 group-hover:text-white transition-all">
                                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"/></svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="isAssign()" class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-gray-900/40 backdrop-blur-md"> 
    <div class="bg-white w-full max-w-xl rounded-[2.5rem] shadow-sm border border-gray-100 overflow-hidden animate-zoom-in">
        <div class="p-8 border-b border-gray-50 flex justify-between items-center">
            <div>
                <h2 class="text-2xl font-black text-gray-900 tracking-tight">Assign Properties</h2>
                <p class="text-gray-500 text-sm">Link specific real estate listings to  <strong>"{{advisor()?.name | titlecase}}"</strong> </p>
            </div>
            <button (click)="closeModal()" class="p-2 bg-gray-50 rounded-full text-gray-400 hover:text-red-500 transition-colors">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
            </button>
        </div>

        <div class="p-8 space-y-6">
            <div class="relative group">
                <input type="text" (input)="onSearch($event)"
                       placeholder="Search advisors by name or expertise..." 
                       class="w-full pl-12 pr-4 py-4 bg-gray-50 border-2 border-transparent focus:border-indigo-500 focus:bg-white rounded-2xl outline-none transition-all"
                >
                <svg class="absolute left-4 top-1/2 -translate-y-1/2 w-6 h-6 text-gray-300 group-focus-within:text-indigo-500 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
            </div>

            <div class="space-y-3 max-h-64 overflow-y-auto pr-2">
              @for (propperty of proRequests(); track propperty._id) {
                <div 
                  (click)="selectAdvisor(propperty.property)"
                  [class]="'flex items-center justify-between p-4 rounded-2xl border-2 transition-all cursor-pointer group ' + 
                           (selectedAdvisorId() === propperty.property?.id ? 'border-indigo-500 bg-indigo-50/30' : 'border-gray-50 hover:border-indigo-200')"
                >
                  <div class="flex items-center gap-4">
                    <img [src]="propperty.property?.imageURL[0]" [alt]="propperty.property?.name" class="w-10 h-10 rounded-xl object-cover" />
                    <div>
                      <p class="text-sm font-bold text-gray-900">{{ propperty?.property?.name |titlecase}}</p>
                      <p [class]="'text-[10px] font-bold uppercase tracking-widest ' + 
                                 (selectedAdvisorId() === propperty.property?.id ? 'text-indigo-600' : 'text-gray-400')">
                        {{ propperty.property?.propertyType }} . {{formatPriceDisplay(propperty.property?.price )}} . {{propperty?.name +" | "+propperty.phone +" | "+propperty.email}}
                      </p>
                    </div>
                  </div>
            
                  <div [class]="'w-6 h-6 rounded-full flex items-center justify-center border-2 transition-all ' + 
                               (selectedAdvisorId() === propperty.property?.id ? 'bg-indigo-600 border-indigo-600' : 'border-gray-200 group-hover:border-indigo-400')">
                    
                    @if (selectedAdvisorId() === propperty.property?.id) {
                      <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                      </svg>
                    }
                  </div>
                </div>
              }
            </div>
        </div>

        <div class="p-8 bg-gray-50 flex gap-4">
            <button (click)="closeModal()" class="flex-1 py-4 font-bold text-gray-500 hover:text-gray-700 transition-colors">Dismiss</button>
            <button (click)="confirmAdvisor()"
            [disabled]="isConfirmDisabled()" class="flex-1 py-4 bg-indigo-600 text-white font-extrabold rounded-2xl shadow-sm shadow-indigo-100 hover:bg-indigo-700 transition-all active:scale-95 disabled:bg-gray-300 disabled:cursor-not-allowed
            enabled:bg-indigo-600 enabled:hover:bg-indigo-700 enabled:shadow-lg enabled:shadow-indigo-200">Confirm Assignment</button>
        </div>
    </div>
</div>